import currency from 'currency.js';

// function that convert number into currency format like ₹1,000.00 with 2 decimal places
export function ccyFormat(num) {
    return currency(num, { symbol: '₹', precision: 2 }).format();
}
